const routes = {
  '/zap-templates': {
    fetch: () =>
      import(
        /* webpackChunkName: 'zap-templates-route' */ 'app/zap-templates/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
